import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "@/lib/api";

export function RenewalStreak({ reloadKey }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/documents/renewal-streak").then((r) => setS(r.data)).catch(() => {}); }, [reloadKey]);
  if (!s || !s.tracked) return null;
  if (s.earned) {
    return (
      <div className="flex items-center gap-3 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2.5 mb-3" data-testid="renewal-streak-badge">
        <span className="h-9 w-9 rounded-full bg-emerald-600 text-white grid place-items-center shrink-0"><Award className="h-5 w-5" /></span>
        <div className="min-w-0"><div className="text-sm font-semibold text-emerald-900">Renewal streak: {s.streak} on time</div>
          <div className="text-xs text-emerald-800">Everything is current and each renewal was done before it expired.</div></div>
      </div>
    );
  }
  return (
    <p className="text-xs text-slate-500 mb-3 flex items-center gap-1.5" data-testid="renewal-streak-hint"><Award className="h-4 w-4 text-slate-400" />
      {s.expired ? "Renew what has expired, then keep renewing on time to earn a Renewal Streak badge." : "Mark a renewal done before its expiry date to start your Renewal Streak badge."}</p>
  );
}
